var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"management_top_box"},[_c('h4',[_vm._t("title")],2)]),_c('div',{staticClass:"d-flex justify-content-end w-100"},[_vm._t("excel")],2),_c('div',[_c('table',{staticClass:"mgt_tbl"},[_c('tbody',[_vm._t("filter")],2)])]),_c('div',{staticClass:"sub_chart_box pie_box"},[_vm._t("graph")],2),_vm._t("paging")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }